import { render, staticRenderFns } from "./departamento-form.vue?vue&type=template&id=39fdb1d5&scoped=true"
import script from "./departamento-form.vue?vue&type=script&lang=js"
export * from "./departamento-form.vue?vue&type=script&lang=js"
import style0 from "./departamento-form.vue?vue&type=style&index=0&id=39fdb1d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39fdb1d5",
  null
  
)

export default component.exports